import { Quotes, Star } from "@phosphor-icons/react";

const ITEMS = [
  { name: "Mehmet K.", role: "Hırdavat toptancısı, İstanbul", text: "Cari bakiyeleri artık defterde aramıyorum. Vadesi geçen faturaları sabah panelde görüp hemen arıyorum." },
  { name: "Ayşe D.", role: "Boya & Yapı Market, Bursa", text: "Stok sayımı eskiden bir günümü alırdı. Şimdi her satışta otomatik düşüyor, kritik seviyede uyarı geliyor." },
  { name: "Hasan Y.", role: "Gıda dağıtım, İzmir", text: "WhatsApp'tan ekstre göndermek müşterilerimle aramdaki tahsilat gerginliğini bitirdi. Herkes aynı rakamı görüyor." },
  { name: "Elif S.", role: "Tekstil atölyesi, Denizli", text: "Online ödeme bağlantısıyla tahsilat süresi yarıya indi. Kredi kartı istemeden ücretsiz denemem de çok iyi oldu." },
  { name: "Burak T.", role: "Oto yedek parça, Ankara", text: "Çek-senet takibi ve hatırlatmalar sayesinde hiçbir vadeyi kaçırmadık. Basit, hızlı ve Türkçe." },
];

export const Testimonials = ({ dark = true }) => (
  <div className="relative overflow-hidden" data-testid="testimonials">
    <div className="promo-marquee gap-4" style={{ animationDuration: "60s" }}>
      {[...ITEMS, ...ITEMS].map((t, i) => (
        <figure key={i} className={`w-[320px] shrink-0 border p-4 ${dark ? "border-white/10 bg-white/5 text-zinc-300" : "border-slate-200 bg-white text-slate-700"}`} data-testid={`testimonial-${i % ITEMS.length}`}>
          <div className="flex items-center justify-between">
            <Quotes weight="fill" className="text-[#fdba74]" size={20} />
            <span className="flex gap-0.5 text-[#fdba74]">{Array.from({ length: 5 }, (_, s) => <Star key={s} weight="fill" size={12} />)}</span>
          </div>
          <blockquote className="mt-2 text-sm leading-relaxed">{t.text}</blockquote>
          <figcaption className="mt-3 text-xs">
            <span className={`font-semibold ${dark ? "text-white" : "text-slate-900"}`}>{t.name}</span>
            <span className={dark ? "text-zinc-500" : "text-slate-500"}> · {t.role}</span>
          </figcaption>
        </figure>
      ))}
    </div>
  </div>
);
